import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Popover, Button, Icon } from 'Components';
import DownloadFromUrl from 'helpers/download';
import { SUBMISSIONS } from 'constants/apis';
import './PowerTablePopover.css';

const PowerTablePopover = (props) => {
  const handleClick = (e, URL) => {
    e.stopPropagation();
    DownloadFromUrl(URL);
  };

  const data = [
    {
      Description: i18n.t('jobs:Tracking Form'),
      url: `${SUBMISSIONS}/${props.SubmissionId}/GetPhysicalTrackingForm`,
    },
    {
      Description: i18n.t('jobs:eCOC Submission Summary'),
      url: `${SUBMISSIONS}/${props.SubmissionId}/GetGenericPDF?SummaryFormat=true`,
    },
    {
      Description: i18n.t('jobs:eCOC Submission Details'),
      url: `${SUBMISSIONS}/${props.SubmissionId}/GetGenericPDF?SummaryFormat=false`,
    },
  ];

  if (props.isCTFDisabled) {
    data.shift();
  }

  return (
    <div className="power-table-popover__container">
      <Popover
        className="power-table-popover"
        placement="bottom-start"
        domRef={props.popoverRef}
        onClick={(e => e.stopPropagation())}
      >
        {
          data.map(obj => (
            <Button key={obj.Description} onClick={e => handleClick(e, obj.url)}>
              <div className="power-table-popover__item" >
                <Icon icon="print" />
                <span>{obj.Description}</span>
              </div>
            </Button>
          ))
        }
      </Popover>
    </div>
  );
};

PowerTablePopover.propTypes = {
  SubmissionId: PropTypes.number,
  popoverRef: PropTypes.shape({}),
  isCTFDisabled: PropTypes.bool,
};

export default PowerTablePopover;



// WEBPACK FOOTER //
// ./src/components/PowerTable/PowerTablePopover/PowerTablePopover.jsx